// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---node-modules-gatsby-plugin-offline-app-shell-js": () => import("/opt/build/repo/node_modules/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---node-modules-gatsby-plugin-offline-app-shell-js" */),
  "component---src-pages-404-js": () => import("/opt/build/repo/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/opt/build/repo/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-landing-page-js": () => import("/opt/build/repo/src/pages/landing-page.js" /* webpackChunkName: "component---src-pages-landing-page-js" */),
  "component---src-pages-login-page-js": () => import("/opt/build/repo/src/pages/login-page.js" /* webpackChunkName: "component---src-pages-login-page-js" */),
  "component---src-pages-profile-page-js": () => import("/opt/build/repo/src/pages/profile-page.js" /* webpackChunkName: "component---src-pages-profile-page-js" */)
}

exports.data = () => import("/opt/build/repo/.cache/data.json")

